import {
    closeIcon,
    facebookButtonIcon,
    googleButtonIcon,
    rocketIcon,
} from "../../../assets";
import {useSocialIntegration} from "./useSocialIntegration";
import s from './socialIntegration.module.css';
import {useAppContext} from "../../../contexts";

const SocialIntegration = (props) => {
    // Destructured props
    const {
        data = {}
    } = props;

    // Component logic data
    const componentProps = useSocialIntegration();

    // Destructured component logic data
    const {
        showSocialIntegration,
        handleShowSocialIntegration
    } = componentProps;

    // Accessibility feature data
    const {
        highContrast,
        socialLoginConfig
    } = useAppContext();

    // Doesn't render anything if the feature isn't enabled
    if (
        !socialLoginConfig["isGeneralEnabled"] ||
        (
            !socialLoginConfig["isGoogleEnabled"] &&
            !socialLoginConfig["isFacebookEnabled"]
        )
    ) {
        return null;
    }

    // The variable name says it all
    const facebookButton =
        (
            !socialLoginConfig["isFacebookEnabled"] ||
            data?.socialIntegration?.facebook?.isIntegrated
        ) ? null : (
            <button onClick={() => window.location.href = "/social/dispatch/auth/id/facebook"}>
                <img
                    src={facebookButtonIcon}
                    alt="Facebook button"
                    className={`${highContrast ? "highImage" : ""}`}
                />
            </button>
        );

    // The variable name says it all
    const googleButton =
        (
            !socialLoginConfig["isGoogleEnabled"] ||
            data?.socialIntegration?.gmail?.isIntegrated
        ) ? null : (
            <button onClick={() => window.location.href = "/social/dispatch/auth/id/google"}>
                <img
                    src={googleButtonIcon}
                    alt="Google button"
                    className={`${highContrast ? "highImage" : ""}`}
                />
            </button>
        );

    return (
        <div className={`
            w-full mt-[2.3rem] mb-[0.5rem] flex flex-col md:flex-row justify-between gap-[1rem] p-[1rem] lg:min-h-[6.25rem] 
            ${showSocialIntegration ? '' : 'hidden'} 
            ${highContrast ? "grayBackground" : "bg-light-gray"}
        `}>
            <div className={'flex justify-between items-start gap-[1rem]'}>
                <img
                    src={rocketIcon}
                    alt="rocket icon"
                    className={`
                        w-[3.75rem] h-[3.75rem] lg:w-[7.5rem] lg:h-[7.5rem] lg:absolute lg:top-[15rem]
                        ${highContrast ? "highImage" : ""}
                    `}
                />
                <span
                    className={`font-bold font-museo leading-5 lg:ml-[9rem] ${highContrast ? "highLabelFourth" : "text-fade-modal"}`}
                >
                    Para facilitar o seu acesso, agora é possível vincular o seu login social na nossa loja vitual, clique nas redes para fazer a vinculação:
                </span>
                <button
                    onClick={handleShowSocialIntegration}
                    className={`md:hidden w-[4rem] flex justify-end items-center`}
                >
                    <img
                        src={closeIcon}
                        alt="close icon"
                        className={`${highContrast ? "highImage" : ""}`}
                    />
                </button>
            </div>
            <div className={'flex justify-center items-center min-w-[21rem]'}>
                <div className={'flex justify-between items-center gap-[1rem] md:gap-[0.5rem]'}>
                    {facebookButton}
                    {googleButton}
                </div>
            </div>
            <div className={`hidden md:flex justify-end items-start`}>
                <button onClick={handleShowSocialIntegration} className={'min-w-[1rem]'}>
                    <img
                        src={closeIcon}
                        alt="close icon"
                        className={`${highContrast ? "highImage" : ""}`}
                    />
                </button>
            </div>
        </div>
    )
}

export default SocialIntegration;
